import React, { useMemo } from 'react';
import ReactDOM from 'react-dom';

const LoadingOverlay = ({ visible, message }) => {
  const lang = useMemo(() => (typeof document !== "undefined" && document.documentElement?.lang) || "ko", []);
  
  if (!visible) return null;

  const defaultMessage = lang === "zh-CN" ? "AI 正在生成..." : "AI가 답변을 생성하고 있습니다...";
  const subMessage = lang === "zh-CN" ? "请稍候。" : "잠시만 기다려 주세요.";

  const overlayNode = (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(255, 255, 255, 0.85)',
      backdropFilter: 'blur(5px)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 999999
    }}>
      <style>
        {`
          .ai-spinner {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            border: 6px solid #f3f3f3;
            border-top: 6px solid var(--util-btn-text, #f472b6);
            border-bottom: 6px solid var(--header-txt-hover, #fbcfe8);
            animation: ai-spin 1.2s linear infinite;
            margin-bottom: 24px;
            box-shadow: 0 0 15px rgba(0,0,0,0.1);
          }
          @keyframes ai-spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          .ai-loading-text {
            font-size: 1.2rem;
            font-weight: 700;
            color: #1f2937;
            letter-spacing: -0.01em;
            background: var(--header-bg, linear-gradient(90deg, #fbcfe8, #f472b6));
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            animation: ai-pulse-text 2s infinite ease-in-out;
          }
          @keyframes ai-pulse-text {
            0% { opacity: 0.8; }
            50% { opacity: 1; }
            100% { opacity: 0.8; }
          }
        `}
      </style>
      <div className="ai-spinner"></div>
      <div className="ai-loading-text">{message || defaultMessage}</div>
      <div style={{ color: '#6b7280', marginTop: '12px', fontSize: '0.95rem', fontWeight: '500' }}>{subMessage}</div>
    </div>
  );

  if (typeof document !== 'undefined') {
    return ReactDOM.createPortal(overlayNode, document.body);
  }

  return overlayNode;
};

export default LoadingOverlay;
